import { Routes } from '@angular/router';
import { LoginComponent } from './pages/public/login/login.component';
import { ForgotPasswordComponent } from './pages/public/forgotten-passsword/forgot-password.component';
import { HomeComponent } from './pages/protected/home/home.component';
import { ProjectsComponent } from './pages/protected/projects/projects.component';
import { ProjectEditComponent } from './pages/protected/project-edit/project-edit.component';
import { ProjectInsightComponent } from './pages/protected/project-insight/project-insight.component';
import { authenticationGuard } from './guards/login.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  {
    path: '',
    component: HomeComponent,
    canActivate: [authenticationGuard()],
    children: [
      { path: '', redirectTo: 'projects', pathMatch: 'full' },
      { path: 'projects', component: ProjectsComponent },
      { path: 'projects/:id', component: ProjectEditComponent },
      { path: 'insight/:id', component: ProjectInsightComponent },
    ],
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
